import React, { useState } from "react";
import Switch from "react-switch";
import Header from "../../components/header/Header"
const Upgardeplan = () => {
  const [isAnnually, setIsAnnually] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [clickedPlan, setClickedPlan] = useState(null);

  const handleToggle = () => {
    setIsAnnually(!isAnnually);
  };

  const handleSelectPlan = (plan) => {
    setSelectedPlan(plan);
  };

  const handleClickButton = (plan) => {
    setClickedPlan(plan);
  };

  return (
    <>
     <Header/>
    <div className=" justify-content-center pt-5 mt-5 ">
      <h2 className="text-center mb-4">
        Choose Your {isAnnually ? "Annual" : "Monthly"} Upgrade Plan
      </h2>

      {/* Updated switch container with proper text alignment */}
      <div className="d-flex justify-content-center align-items-center mb-4">
        <div
          className="position-relative"
          style={{ width: "100px", height: "30px" }}
        >
          <Switch
            checked={isAnnually}
            onChange={handleToggle}
            offColor="#888"
            onColor="#00aaff"
            offHandleColor="#fff"
            onHandleColor="#fff"
            height={30}
            width={100}
            checkedIcon={
              <div
                className="h-100 d-flex align-items-center justify-content-center ps-5"
                style={{
                  paddingRight: "10px",
                  color: "white",
                  fontSize: "15px",
                }}
              >
                Annually
              </div>
            }
            uncheckedIcon={
              <div
                className="h-100 d-flex align-items-center justify-content-center"
                style={{
                  paddingRight: "20px",
                  color: "white",
                  fontSize: "15px",
                }}
              >
                Monthly
              </div>
            }
          />
        </div>
      </div>
      <div className="row justify-content-center d-flex gap-0 mt-4">
        {/* Free Plan Card */}
        <div
          className={`col-sm-4 col-md-4 col-lg-4 mb-4 w-25 ${
            selectedPlan === "Free" ? "d-flex justify-content-center" : ""
          }`}
        >
          <div
            className="card upgrade-card"
            onClick={() => handleSelectPlan("Free")}
            style={{
              cursor: "pointer",
              border: selectedPlan === "Free" ? "2px solid black" : "",
              transition: "all 0.3s ease",
            }}
          >
            <div className="card-body">
              <h2 className="card-title text-center fw-bold mb-3 fs-4">Free</h2>
              <h3 className="text-center">$0 USD/month</h3>
              <p className="card-text fs-6 text-secondary mb-4 text-center">
                Explore how AI can help you with everyday tasks.
              </p>
              <div className="text-center mb-4">
                <button
                  className="btn btn-outline dark w-100"
                  onClick={() => handleClickButton("Free")}
                >
                  Your current plan
                </button>
              </div>
              <ul className="list-unstyled">
                <li className="mb-2">
                  ✓ Access to GPT-4 mini for basic resume content suggestions.
                </li>
                <li className="mb-2">
                  ✓ Use of basic resume templates to structure your resume.
                </li>
                <li className="mb-2">✓ Download your resume in PDF format.</li>
                <li className="mb-2">
                  ✓ AI content recommendations for simple sections.
                </li>
                <li className="mb-2">
                  ✓ Limited access to customization and additional features.
                </li>
                <li className="mb-2">
                  ✓ Basic AI content suggestions for resume building.
                </li>
                <li className="mb-2">
                  ✓ Limited templates to structure your resume.
                </li>
                <li className="mb-2">✓ Download resume in PDF format.</li>
                <li className="mb-2">✓ Basic customization tools.</li>
                <li className="mb-2">
                  ✓ Free access to all basic features without hidden fees.
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Plus Plan Card */}
        <div
          className={`col-sm-4 col-md-4 col-lg-4 mb-4 w-25 ${
            selectedPlan === "Plus" ? "d-flex justify-content-center" : ""
          }`}
        >
          <div
            className={`card upgrade-card ${
              selectedPlan === "Plus" ? "popular" : "black"
            }`}
            onClick={() => handleSelectPlan("Plus")}
            style={{
              cursor: "pointer",
              border: selectedPlan === "Plus" ? "2px solid black" : "",
            }}
          >
            <div className="card-body">
              <h2 className="card-title text-center fw-bold mb-3 fs-4">Plus</h2>
              <h3 className="text-center">
                {isAnnually ? "$ 200 USD/year" : "$20 USD/month"}
              </h3>
              <p className="card-text fs-6 text-secondary mb-4 text-center">
                Level up productivity and creativity with expanded access.
              </p>
              <div className="text-center mb-4">
                <button
                  className="btn btn-outline-primary w-100"
                  onClick={() => handleClickButton("Plus")}
                >
                  Get Plus
                </button>
              </div>
              <ul className="list-unstyled">
                <li className="mb-2">
                  ✓ Premium Templates Layouts Choose from a variety of
                  professionally designed templates to make your resume shine
                </li>
                <li className="mb-2">
                  ✓ Download in Multiple Formats Export your resume in PDF or
                  Word format for easy sharing and printing.
                </li>
                <li className="mb-2">
                  ✓ Extended AI Recommendations Get personalized suggestions for
                  every section, including work experience, skills, and
                  education
                </li>
                <li className="mb-2">✓Limited access to o1 and o1-mini</li>
                <li className="mb-2">✓ Opportunities to test new features</li>
                <li className="mb-2">
                  ✓ Save/Edit Anytime Keep your resume up to date by saving your
                  progress and making changes whenever you want
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* Pro Plan Card */}
        <div
          className={`col-sm-4 col-md-4 col-lg-4 mb-4 w-25 ${
            selectedPlan === "Pro" ? "d-flex justify-content-center" : ""
          }`}
        >
          <div
            className="card upgrade-card"
            onClick={() => handleSelectPlan("Pro")}
            style={{
              cursor: "pointer",
              border: selectedPlan === "Pro" ? "2px solid black" : "",
            }}
          >
            <div className="card-body">
              <h2 className="card-title text-center fw-bold mb-3 fs-4">Pro</h2>
              <h3 className="text-center">$ 400 USD/month</h3>
              <p className="card-text fs-6 text-secondary mb-4 text-center">
                Get the best of OpenAI with the highest level of access.
              </p>
              <div className="text-center mb-4">
                <button
                  className="btn btn-outline-dark w-100"
                  onClick={() => handleClickButton("Pro")}
                >
                  Get Pro
                </button>
              </div>
              <ul className="list-unstyled">
                <li className="mb-2">✓ Everything in Plus</li>
                <li className="mb-2">
                  ✓ Get detailed, personalized suggestions
                </li>
                <li className="mb-2">✓ Expert Resume Review</li>
                <li className="mb-2">✓ Advanced design and layout options</li>
                <li className="mb-2">✓ Create and store multiple versions</li>
                <li className="mb-2">✓ Detailed, personalized suggestions</li>
                <li className="mb-2">✓ Expert resume review</li>
                <li className="mb-2">✓ Unlimited premium templates</li>
                <li className="mb-2">
                  ✓ save/Edit Anytime Keep your resume up to date by saving your
                  progress and making changes whenever you want
                </li>
                <li className="mb-2">
                  ✓ AI handles the heavy lifting with suggestions tailored to
                  your experience and goals
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Upgardeplan;
